import React from "react";

import {
  Typography,
  TextField,
  InputAdornment,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  MenuItem,
  FormControlLabel,
  FormGroup,
  InputLabel,
  Select,
} from "@material-ui/core";
import "./Expense.css";
import Autocompete from "../JobRequisition/Autocompete";
export default function Expense() {
  return (
    <>
      <div class="Expense" style={{width: '100%'}}>
        <h1>Create Expense Report</h1>
        <hr />
        <div className="field-container">
          <div className="field-titles">
            Expense Report<span className="mandatory">*</span>
          </div>
          <div className="field-ans">
            <br />
            <br />
            <span className="work-h"></span>For Contingent Worker: Test Change
          </div>
        </div>
        <div className="field-container">
          <div className="field-titles">Creation Options</div>
          <div className="field-ans">
            <span className="mandatory">*</span>
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="new"
                name="radio-buttons-group"
              >
                <FormControlLabel
                  value="new"
                  control={<Radio />}
                  label="  Create New Expense Report "
                />

                <FormControlLabel
                  value="old"
                  control={<Radio />}
                  label="Copy Previous Expense Report "
                />
                <Autocompete />
                <FormControlLabel
                  value="old"
                  control={<Radio />}
                  label="     Create New Expense Report from Spend Authorization"
                />
                <Autocompete />
              </RadioGroup>
            </FormControl>
          </div>
        </div>
        <div className="field-container">
          <div className="field-titles">
            Memo <span className="mandatory">*</span>
          </div>
          <div className="field-ans">
            <textarea style={{width: '100%'}} rows={5} cols={100} />
          </div>
        </div>
        <div className="field-container">
          <div className="field-titles">
            Company<span className="mandatory">*</span>
          </div>
          <div className="field-ans">
            <Autocompete />
          </div>
        </div>

        <div className="field-container">
          <div className="field-titles">
            Expense Report Date<span className="mandatory">*</span>
          </div>
          <div className="field-ans">
            <TextField
              id="date"
              type="date"
              style={{ padding: "10px", color: "black" }}
              defaultValue="YYYY/MM/DD"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
        </div>
        <div className="field-container">
          <div className="field-titles">
            Worktags<span className="mandatory">*</span>
          </div>
          <div className="field-ans">
            <Autocompete />
          </div>
        </div>
        <div className="field-container">
          <div className="field-titles">
            Enable Tax<span className="mandatory">*</span>
          </div>
          <div className="field-ans">
            {" "}
            <br />
            <FormGroup>
              <FormControlLabel
                control={<Checkbox defaultChecked />}
                label=""
              />
            </FormGroup>
          </div>
        </div>
        <div className="button-div">
          <button className="ok-btn">Ok</button>
          <button className="cancel-btn">Cancel</button>
        </div>
      </div>
    </>
  );
}
